import { keys } from 'underscore';
import Backbone from 'backbone';

import { SimpleForm } from '@bingads-webui/simple-form';

import template from './keyword-editor-template.pug';

/**
 * Keyword editor view
 * @private
 */
export class KeywordEditor extends Backbone.View {
  /**
   * init Keyword Editor, it will generate a view based on
   * options, and show the view based on the target location
   * @private
   * @param {Object} target - the input element that keyword editor should attach to
   * @param {Object} options - editor model and cursor position info
   * @param {I18n} i18n - i18n object that provides getString
   * @returns {undefined} - initialize view
   */
  initialize({
    target,
    options: {
      defaultText = '',
      keywordCase,
      prefix = '',
      suffix = '',
    },
    updateAndCloseCallback,
    i18n,
  }) {
    this.target = target;
    this.updateAndCloseCallback = updateAndCloseCallback;

    const keywords = {
      TitleCase: 'KeyWord',
      SentenceCase: 'Keyword',
      LowerCase: 'keyword',
    };

    const schema = {
      name: 'Keyword',
      type: 'object',
      properties: {
        defaultText: {
          type: 'string',
        },
        keywordCase: {
          type: 'string',
          enum: [...keys(keywords)],
        },
        syntax: {
          type: 'string',
        },
      },
      required: ['defaultText'],
    };

    const fields = [
      {
        property: 'defaultText',
        label: i18n.getString('KeywordEditor_DefaultText_Label'),
        validators: {
          required: {
            message: i18n.getString('KeywordEditor_DefaultText_RequiredValidationMessage'),
          },
        },
      },
      {
        property: 'keywordCase',
        label: i18n.getString('KeywordEditor_Case_Label'),
        control: 'radios',
        valueMessages: {
          TitleCase: i18n.getString('KeywordEditor_Case_TitleCase'),
          SentenceCase: i18n.getString('KeywordEditor_Case_SentenceCase'),
          LowerCase: i18n.getString('KeywordEditor_Case_LowerCase'),
        },
      },
    ];

    const model = {
      defaultText,
      keywordCase,
    };

    this.form = new SimpleForm({
      schema,
      fields,
      model,
      template,
      i18n,
    });

    this.form.on('save', (newModel) => {
      const keywordText = keywords[newModel.keywordCase];
      const newValue = `${prefix}{${keywordText}:${newModel.defaultText}}${suffix}`;
      const cursorPosition = newValue.length - suffix.length;
      this.updateAndCloseCallback({
        newValue,
        cursorPosition,
        isSelectedByUser: true,
      });
    });

    this.form.on('cancel', () => {
      this.updateAndCloseCallback({ isCancel: true });
    });

    return this;
  }

  render() {
    this.$el.append(this.form.render().el);
    return this;
  }
}
